/**
 * Query keys para invalidación y cache de miembros de cliente.
 *
 * @remarks
 * Incluye `clientId` en todas las keys para permitir invalidación selectiva
 * por cliente sin afectar otros queries de la app.
 *
 * @example
 * CLIENT_MEMBERS_KEYS.byClient('client-123')
 * // ['client-members', 'client-123']
 */
import type { ClientMembersQueryParams } from '../api/clientMembers.service';

export const CLIENT_MEMBERS_KEYS = {
  all: ['client-members'] as const,
  byOrg: (orgId: string) => ['client-members', orgId] as const,
  byClient: (orgId: string, clientId: string) => ['client-members', orgId, clientId] as const,
  list: (orgId: string, clientId: string, params: ClientMembersQueryParams) =>
    ['client-members', orgId, clientId, 'list', params] as const,
};
